import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
const shortTestimonials = [{
  quote: 'I booked my first full-planning client at $3,500 — double what I was going to charge — because I finally had real packages and a real process to show her.',
  author: 'Sarah M.',
  role: 'Wedding Planner'
}, {
  quote: 'The minute-by-minute timeline saved my last wedding. A vendor showed up 40 minutes late and nobody — not even the bride — ever knew there was a problem.',
  author: 'Jasmine R.',
  role: 'Planner & Stylist'
}, {
  quote: 'Vendors treat me completely differently now. I walk into production meetings with agendas and checklists, and they follow my lead instead of walking all over me.',
  author: 'Emily T.',
  role: 'Event & Wedding Planner'
}];
const moreTestimonials = [{
  quote: 'Volume 5 alone is worth ten times the price. I ran my first solo wedding with the minute-by-minute timeline and the mother of the bride asked for my card.',
  author: 'Wedding Planner'
}, {
  quote: 'I used the Discovery Call Framework on a Tuesday. By Friday I had signed my highest-paying client ever.',
  author: 'Planner, 2nd year'
}, {
  quote: 'I stopped feeling like a fraud. I open the volume, follow the system, and clients keep telling me how “organized” I am. If only they knew it all came from one PDF.',
  author: 'New Wedding Planner'
}];
export function App() {
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-gold selection:text-ink" data-id="element-0" data-mp="85uivqhn5x3a">
      <MetaPixel data-id="element-1" data-mp="3gkv0fqj99ncr" />
      <main data-id="element-2" data-mp="3gmfwxlp4rgd9">
        <Hero data-id="element-3" data-mp="3gm65ruscn35z" />
        <SocialProofBar data-id="element-4" data-mp="3glnxu0wbr0i8" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-5" data-mp="3bmbe3p0r29jv" />
        <PainGrid data-id="element-6" data-mp="3bo4j6zvpslpr" />
        <BigIdea data-id="element-7" data-mp="3bkgtycxaylgu" />
        <ProductReveal data-id="element-8" data-mp="3qaxuzv60z9d7" />
        <Tomes data-id="element-9" data-mp="3qc95edtz7fda" />
        <Bonuses data-id="element-10" data-mp="3qcr0h74wjnjm" />
        <Urgency data-id="element-11" data-mp="3qdai0mqn49x4" />
        <Pricing data-id="element-12" data-mp="3lkhe212zx5m3" />
        <Transformation data-id="element-13" data-mp="3ljxwilh9cj8l" />
        <Testimonials testimonials={moreTestimonials} title="More planners, more weddings run right" background="ivory" data-id="element-14" data-mp="3ljphoo1kr3ur" />
        <Guarantee data-id="element-15" data-mp="2sw20zk3fcxde" />
        <Faq data-id="element-16" data-mp="2swlkv6cmxvu2" />
        <CostOfInaction data-id="element-17" data-mp="2suqv9eqf5fjn" />
        <Close data-id="element-18" data-mp="2svjyi5q65mx1" />
      </main>
      <Footer data-id="element-19" data-mp="18drjrx1hphec" />
    </div>;
}